import useUserDataContext from '@/customHooks/useUserDataContext'
import { ResponseType, useIsLoggedQuery } from '@/graphql/generated'
import { Navigate, Outlet, useLocation } from 'react-router'
import styled from 'styled-components'
import { pathURL } from '../constants/urls'
import { LoadingSpinner } from '../ui/atoms'

const SpinnerContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const InitialAuthCheck = () => {
  const location = useLocation()
  const { data, loading } = useIsLoggedQuery({
    skip: location.pathname === '/' // No necesitamos hacer la query si ya estamos en la raíz
  })
  const { clearUserData } = useUserDataContext()

  if (loading) {
    return (
      <SpinnerContainer>
        <LoadingSpinner />
        <p>Loading</p>
      </SpinnerContainer>
    )
  }

  // Si estamos en una ruta protegida y el servidor dice que no estamos logueados
  if (data?.isLogged.responseType !== ResponseType.Success && location.pathname !== '/') {
    clearUserData()
    return <Navigate to={`/${pathURL.LOGIN}`} state={{ from: location }} replace />
  }

  return <Outlet />
}